import { KBFolderPage } from '@/modules/gpt-chats/components/knowledge-base/kb-selected-folder';

export const KnowledgeBaseFolder = ({ folderId }: { folderId: string }) => {
  return <KBFolderPage folderId={folderId} />;
};
